import { MyThunkResult } from 'store';

import { AdminUser } from 'models/adminUser';

import { doLoadAdminUserList, doUpdateUser, doCreateInviteUser, doLoadAllUserList } from '../action-creators/adminUser';
import { profile, axiosConfig } from '../api';

interface AdminUserResponse {
  data: AdminUser[];
}

export const fetchUsersAndInvites = (): MyThunkResult<Promise<void>> => (dispatch) =>
  profile.get<AdminUserResponse>('/Invite/GetAllUsersAndInvites/', axiosConfig).then((response) => {
    const { data } = response.data;
    dispatch(doLoadAdminUserList(data as AdminUser[]));
  });

export const fetchAllUsersActive = (companyId: string): MyThunkResult<Promise<void>> => (dispatch) =>
  profile.get<AdminUserResponse>('/Users/GetAllActive', axiosConfig).then((response) => {
    const { data } = response.data;
    dispatch(doLoadAdminUserList(data as AdminUser[]));
  });

export const fetchAllUsers = (companyId: string): MyThunkResult<Promise<void>> => (dispatch) =>
  profile.get<AdminUserResponse>('/Users/GetAll', axiosConfig).then((response) => {
    const { data } = response.data;
    dispatch(doLoadAllUserList(data as AdminUser[]));
  });

export const createInviteOrUpdateUser = (
  user: AdminUser,
  companyId: string,
  userId?: string,
): MyThunkResult<Promise<void>> => (dispatch) => {
  const isUpdate = user.id !== '';
  const { isInvite } = user;
  const endPoint = isInvite ? 'invite' : 'users';

  if (!user.companyId) user.companyId = companyId;

  delete user.country;

  if (isUpdate) {
    const userToUpdate = { ...user, userAdminId: userId };
    if (isInvite) {
      delete userToUpdate.emailRappi;
      delete userToUpdate.idRappi;
    } else {
      delete userToUpdate.companyId;
    }
    delete userToUpdate.validatedEmail;
    delete userToUpdate.isInvite;

    return profile
      .put(`/${endPoint}/${userToUpdate.id}`, {
        ...userToUpdate,
        pushWhatsapp: userToUpdate.sendWhatsapp,
      })
      .then(() => {
        dispatch(doUpdateUser(user));
      });
  }
  return profile
    .post('invite', {
      ...user,
      pushWhatsapp: user.sendWhatsapp,
    })
    .then((response) => {
      dispatch(doCreateInviteUser(response.data));
    });
};

export const deleteUser = async (userId?: string, isInvited?: boolean): Promise<void> => {
  await profile.delete(`${isInvited ? 'Invite' : 'Users'}/${userId}`).catch((error) => {
    throw error;
  });
};
